export enum CupLidType {
    Standard = '0',
    StandardEcoCompostable = '1',
    Reserve = '2',
    ReserveEcoCompostable = '3',
  }

export const cupLidTypeTranslationMap: Record<CupLidType, string> = {
  [CupLidType.Standard]: 'configurations.cup_lid_types.standard',
  [CupLidType.StandardEcoCompostable]: 'configurations.cup_lid_types.standard_eco_compostable',
  [CupLidType.Reserve]: 'configurations.cup_lid_types.reserve',
  [CupLidType.ReserveEcoCompostable]: 'configurations.cup_lid_types.reserve_eco_compostable',
};
  